import axios from 'axios';

import { axiosHeader, getV1RootUrl } from 'common/helpers/apiHelper';

export const listClubMemberships = (customerId, queryString) => {
  if (queryString) {
    return axios.get(
      `${getV1RootUrl()}/customer/${customerId}/club-membership?populate=nextClubShipment&${queryString}`,
      axiosHeader()
    );
  }
  return axios.get(
    `${getV1RootUrl()}/customer/${customerId}/club-membership?populate=nextClubShipment`,
    axiosHeader()
  );
};

export const getClubMembership = (customerId, clubMembershipId) =>
  axios.get(
    `${getV1RootUrl()}/customer/${customerId}/club-membership/${clubMembershipId}?populate=nextClubShipment`,
    axiosHeader()
  );

export const editClubMembership = (
  customerId,
  clubMembershipId,
  clubMembership
) =>
  axios.put(
    `${getV1RootUrl()}/customer/${customerId}/club-membership/${clubMembershipId}`,
    clubMembership,
    axiosHeader()
  );

export const cancelClubMembership = (
  customerId,
  clubMembershipId,
  clubMembership
) =>
  axios.put(
    `${getV1RootUrl()}/customer/${customerId}/club-membership/${clubMembershipId}/cancel`,
    clubMembership,
    axiosHeader()
  );

export const addClubMembershipHold = (customerId, clubMembershipId, onHold) =>
  axios.post(
    `${getV1RootUrl()}/customer/${customerId}/club-membership/${clubMembershipId}/on-hold`,
    onHold,
    axiosHeader()
  );

export const editClubMembershipHold = (
  customerId,
  clubMembershipId,
  id,
  onHold
) =>
  axios.put(
    `${getV1RootUrl()}/customer/${customerId}/club-membership/${clubMembershipId}/on-hold/${id}`,
    onHold,
    axiosHeader()
  );

export const deleteClubMembershipHold = (customerId, clubMembershipId, id) =>
  axios.delete(
    `${getV1RootUrl()}/customer/${customerId}/club-membership/${clubMembershipId}/on-hold/${id}`,
    axiosHeader()
  );
